import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { CALENDLY_LINK } from '../../../utils/constants';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-slate-50 via-white to-sky-50 py-20 lg:py-28">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2260%22%20height%3D%2260%22%20viewBox%3D%220%200%2060%2060%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Cg%20fill%3D%22%23e2e8f0%22%20fill-opacity%3D%220.3%22%3E%3Ccircle%20cx%3D%2230%22%20cy%3D%2230%22%20r%3D%221%22/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')] opacity-40"></div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="inline-flex items-center px-4 py-2 bg-accent/10 border border-accent/20 rounded-full">
                <Icon name="Award" size={16} className="text-accent mr-2" />
                <span className="text-sm font-medium text-accent">CVA & CPA Certified • Court-Nominable</span>
              </div>

              <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-primary leading-tight">
                Business Valuation
                <span className="block text-accent">Excellence</span>
              </h1>

              <p className="text-xl text-text-secondary leading-relaxed max-w-2xl">
                Defensible valuations for critical business decisions. Our CVA & CPA-certified methodology delivers court-admissible reports that stand up to scrutiny and support your strategic objectives.
              </p>
            </div>

            {/* Key Benefits */}
            <div className="grid sm:grid-cols-3 gap-6">
              {[
                { icon: 'Shield', title: 'NACVA & AICPA Compliant', desc: 'NACVA & AICPA standards' },
                { icon: 'Clock', title: '2-4 Weeks', desc: 'Typical delivery' },
                { icon: 'Scale', title: 'Court Ready', desc: 'Litigation support' }
              ].map((benefit, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
                    <Icon name={benefit.icon} size={20} className="text-accent" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-primary">{benefit.title}</h3>
                    <p className="text-sm text-text-secondary">{benefit.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                variant="default"
                size="lg"
                iconName="Calendar"
                iconPosition="left"
                className="sm:w-auto"
                asChild
              >
                <Link to="/book-consultation">
                  Free Consultation
                </Link>
              </Button>
              {/* <Button
                variant="outline"
                size="lg"
                iconName="Download"
                iconPosition="left"
                className="sm:w-auto"
              >
                Sample Report
              </Button> */}
            </div>
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="relative bg-white rounded-2xl shadow-brand-lg p-8 border border-border">
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-semibold text-primary">Valuation Summary</h3>
                  <div className="px-3 py-1 bg-success/10 text-success text-sm font-medium rounded-full">
                    Final Report
                  </div>
                </div>

                <div className="space-y-4">
                  <div className="flex justify-between items-center py-3 border-b border-border">
                    <span className="text-text-secondary">Income Approach</span>
                    <span className="font-semibold text-primary">$2.8M</span>
                  </div>
                  <div className="flex justify-between items-center py-3 border-b border-border">
                    <span className="text-text-secondary">Market Approach</span>
                    <span className="font-semibold text-primary">$3.1M</span>
                  </div>
                  <div className="flex justify-between items-center py-3 border-b border-border">
                    <span className="text-text-secondary">Asset Approach</span>
                    <span className="font-semibold text-primary">$2.5M</span>
                  </div>
                  <div className="flex justify-between items-center py-4 bg-accent/5 px-4 rounded-lg">
                    <span className="font-semibold text-primary">Concluded Value</span>
                    <span className="text-xl font-bold text-accent">$2.8M</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Floating Elements */}
            <div className="absolute -top-4 -right-4 w-20 h-20 bg-accent/10 rounded-full flex items-center justify-center">
              <Icon name="TrendingUp" size={32} className="text-accent" />
            </div>
            <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-success/10 rounded-full flex items-center justify-center">
              <Icon name="CheckCircle" size={24} className="text-success" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;